module.exports = __webpack_public_path__ + "img/logo.e6270326.svg";